import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { configureStore } from "src/store";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { CookiesProvider } from 'react-cookie';
import ReactGA from 'react-ga';
import { getCookie } from './cookie'

const TRACKING_ID = "UA-190483212-1"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const store = configureStore();

// this needs to be called 2 cases:
// 1- logged-in user opens the app(how it is now)
// 2- non logged-in user, after he logges in(somewhere else)
const user_id = getCookie("user_id");
if (user_id) {
  window.ga('set', 'userId', user_id);
}

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
